import NotificationsItemSideBarTemplate from '@front/templates/NotificationsItemSideBarTemplate.html';
import { ControlsTypes } from '../../../UtilsClasses/FactoryConstants';
import { Control } from '../../Control';
export class NotificationsItemSideBar extends Control {
    constructor() {
        super();
        this.Notification = null;
        this.ItemID = null;
    }
    oncomplete() {
        super.oncomplete();
        this.setDataNotifications();
        this.on('cardClick', this.onCardClick);
        this.observe('notification', this.setDataNotifications);
    }
    setDataNotifications() {
        const notification = this.get('notification');
        if (isNullOrUndefined(notification)) {
            return;
        }
        this.Notification = notification;
        this.ItemID = notification.ID;
        const Title = notification.Title;
        const Date = notification.Date;
        const OnlyText = notification.OnlyText;
        const isUnread = notification.IsUnread;
        const isSelected = notification.IsSelected;
        const rgbColor = this.hexToRgba(notification.colorHEXstr);
        void this.set({
            Title,
            Date,
            OnlyText,
            rgbColor,
            isUnread,
            isSelected
        });
    }
    hexToRgba(hex) {
        hex = hex.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        return 'rgb(' + r + ', ' + g + ', ' + b + ')';
    }
    getType() {
        return ControlsTypes.NotificationsItemSideBar;
    }
    onCardClick() {
        this.fire('onCardClick', this);
    }
}
Control.extendWith(NotificationsItemSideBar, {
    template: NotificationsItemSideBarTemplate,
    data: function () {
        return {
            notification: null,
            Title: null,
            Date: null,
            OnlyText: null,
            rgbColor: 'transparent',
            isUnread: true,
            isSelected: false
        };
    }
});
